import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import * as APITypes from "~/API";
import { translateLeaseTypeOption } from "~/utils/lease/translateLeaseType";

export const LeaseTypeTag = ({ type }: { type: APITypes.LeaseTypeOptions }) => {
  const { t } = useTranslation();
  const color = "blue";

  return (
    <Tag color={color}>{translateLeaseTypeOption(type, t)}</Tag>
  );
};
